import axios from "axios";
import parse from "html-react-parser";
import React, { Component } from "react";
import { Mention, MentionsInput } from "react-mentions";
import { connect } from "react-redux";
import { updateCommentCount } from "../../_actions/commentActions";
import {
  COMMENTS_ENDPOINT,
  SHOW_MY_TEAM_MEMBERS,
} from "../../_actions/endpoints";
import { analyticsTrackEvent } from "../../_utils/common";
import { ShowCenterSpinner } from "../common/statelessView";
import { isEmpty } from "lodash";
import {
  FaCheckCircle,
  FaComments,
  FaEllipsisV,
  FaPencilAlt,
  FaTrash,
  FaUserCircle,
} from "react-icons/fa";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Button,
  ButtonGroup,
  Box,
  Flex,
  Text,
  Icon,
  Divider,
  Image,
} from "@chakra-ui/react";
import { useTranslation, withTranslation } from "react-i18next";
import TldrChakraSelect from "../common/TldrChakraSelect";
import { commentSelectorStyles } from "../styled/details/stylesSelect";

export const panelOptions = [
  { value: true, label: "Unresolved" },
  { value: false, label: "Resolved" },
];

const imageStyles = {
  height: "100%",
  width: "100%",
  borderRadius: "full",
  objectFit: "cover",
  maxW: "30px",
};
const iconStyles = {
  height: "100%",
  width: "100%",
  fill: "white",
  alignSelf: "center",
};

const suggestionBox = {
  h: "2rem",
  w: "2rem",
  border: "2px solid",
  borderColor: "brand.glass_light_10",
  borderRadius: "full",
};
const nameHead = {
  fontSize: "0.875rem",
  textTransform: "capitalize",
  fontWeight: 500,
};
const nameDesc = {
  fontSize: "0.75rem",
  color: "gray.200",
  lineHeight: 1,
};
const actionIcon = {
  position: "relative",
  fontSize: "0.875rem",
  width: "10px",
  height: "25px",
  textAlign: "center",
  marginLeft: "auto",
};
const commentCard = {
  borderRadius: "8px",
  background: "brand.glass_dark_08",
  border: "none",
  padding: "1rem",
  marginBottom: "1rem",
  maxWidth: "370px",
};
const NewCommentInputBox = ({
  newComment,
  comment,
  parentId,
  members,
  onSetComment,
  onSetMember,
  onCreateComment,
  isSubmitting,
  onDiscardComment,
  replyPanelOpen,
}) => {
  const membersList = members.map((member) => ({
    ...member,
    id: member.id.toString(),
    display: member.display_name.trim() !== "" ? member.display_name : member.email,
  }));
  const { t } = useTranslation(["navbar", "common"]);

  return (
    <>
      <MentionsInput
        className="comment-text-input"
        value={newComment}
        placeholder={t("comments_placeholder")}
        onChange={(event) => onSetComment(event)}
        markup="@__display__"
        style={newComment.length > 0 && { minHeight: "90px" }}
      >
        <Mention
          trigger="@"
          markup="<span>@__display__</span>"
          displayTransform={(id, display) => {
            return `@${display}`;
          }}
          data={newComment.length >= 2 ? membersList : []}
          renderSuggestion={(suggestion, search, highlightedDisplay) => {
            return (
              <Flex align="center" m={0} key={"p" + suggestion.id}>
                <Flex justify="center" textAlign="center" borderRadius="full">
                  <Box sx={suggestionBox}>
                    {suggestion.profile_picture ? (
                      <Image
                        src={suggestion.profile_picture}
                        alt="profile"
                        sx={imageStyles}
                      />
                    ) : (
                      <Icon as={FaUserCircle} sx={iconStyles} />
                    )}
                  </Box>
                </Flex>
                <Flex direction="column" color="gray.100" ml={2} mb={1}>
                  <Text sx={nameHead}>{suggestion.display_name}</Text>
                  <Text sx={nameDesc}>{suggestion.email}</Text>
                </Flex>
              </Flex>
            );
          }}
          onAdd={(id, display) => onSetMember(id, display)}
        />
      </MentionsInput>

      {!parentId && newComment.length >= 1 && (
        <Box textAlign="right">
          <ButtonGroup mt={2}>
            <Button size="sm" onClick={() => onDiscardComment("")}>
              {t("cancel", { ns: "common" })}
            </Button>
            <Button
              size="sm"
              type="submit"
              disabled={!newComment}
              onClick={() => onCreateComment(null, "newcomment")}
              variant="solid"
            >
              {t("comment_btn")}
            </Button>
          </ButtonGroup>
        </Box>
      )}
      {!replyPanelOpen && <ShowCenterSpinner loaded={!isSubmitting} />}
    </>
  );
};

const CommentInputBox = ({
  newComment,
  comment,
  parentId,
  members,
  onSetComment,
  onSetMember,
  onCreateComment,
  isSubmitting,
  onDiscardComment,
}) => {
  const membersList = members.map((member) => ({
    ...member,
    id: member.id.toString(),
    display: member.display_name.trim() !== "" ? member.display_name : member.email,
  }));
  const { t } = useTranslation(["navbar", "common"]);

  return (
    <>
      <MentionsInput
        className="comment-text-input"
        value={comment}
        placeholder={t("comments_placeholder")}
        onChange={(event) => onSetComment(event)}
        markup="@__display__"
        style={comment.length > 0 && { minHeight: "90px" }}
      >
        <Mention
          trigger="@"
          markup="<span>@__display__</span>"
          displayTransform={(id, display) => {
            return `@${display}`;
          }}
          data={comment.length >= 2 ? membersList : []}
          renderSuggestion={(suggestion, search, highlightedDisplay) => {
            return (
              <Flex align="center" m={0} key={"p" + suggestion.id}>
                <Flex justify="center" align="center" borderRadius="full">
                  <Box sx={suggestionBox}>
                    {suggestion.profile_picture ? (
                      <Image
                        src={suggestion.profile_picture}
                        alt="profile"
                        sx={imageStyles}
                      />
                    ) : (
                      <Icon as={FaUserCircle} sx={iconStyles} />
                    )}
                  </Box>
                </Flex>
                <Flex direction="column" color="gray.100" ml={2}>
                  <Text sx={nameHead}>{suggestion.display_name}</Text>
                  <Text sx={nameDesc}>{suggestion.email}</Text>
                </Flex>
              </Flex>
            );
          }}
          onAdd={(id, display) => onSetMember(id, display)}
        />
      </MentionsInput>

      {!parentId && comment.length >= 1 && (
        <Box textAlign="right">
          <ButtonGroup mt={3}>
            <Button size="sm" onClick={() => onDiscardComment("")}>
              {t("cancel", { ns: "common" })}
            </Button>
            <Button
              size="sm"
              type="submit"
              disabled={!comment}
              onClick={() => onCreateComment(null)}
              variant="solid"
            >
              {t("comment_btn")}
            </Button>
          </ButtonGroup>
        </Box>
      )}

      {parentId && comment.length >= 1 && (
        <Box textAlign="right">
          <ButtonGroup mt={2}>
            <Button
              size="sm"
              variant="secondary"
              onClick={() => onDiscardComment()}
            >
              {t("cancel", { ns: "common" })}
            </Button>

            <Button
              size="sm"
              type="submit"
              disabled={!comment}
              onClick={() => onCreateComment(parentId)}
              variant="solid"
            >
              {t("reply", { ns: "common" })}
            </Button>
          </ButtonGroup>
        </Box>
      )}

      <ShowCenterSpinner loaded={!isSubmitting} />
    </>
  );
};

const UpdateCommentInputBox = ({
  comment,
  commentObj,
  members,
  onDiscardComment,
  onSetComment,
  onSetMember,
  onUpdateComment,
}) => {
  const { t } = useTranslation(["common"]);
  const membersList = members.map((member) => ({
    ...member,
    id: member.id.toString(),
    display: member.display_name.trim() !== "" ? member.display_name : member.email,
  }));

  return (
    <>
      <MentionsInput
        placeholder={t("edit")}
        className="comment-text-input"
        value={comment}
        onChange={(event) => onSetComment(event)}
        markup="@__display__"
        style={comment.length > 0 && { minHeight: "90px" }}
      >
        <Mention
          trigger="@"
          markup="<span>@__display__</span>"
          displayTransform={(id, display) => {
            return `@${display}`;
          }}
          data={comment.length >= 2 ? membersList : []}
          onAdd={(id, display) => onSetMember(id, display)}
          renderSuggestion={(suggestion, search, highlightedDisplay) => {
            return (
              <Flex alignItems="center" key={"p" + suggestion.id}>
                <Flex justify="center" align="center" borderRadius="full">
                  {suggestion.profile_picture ? (
                    <Image
                      src={suggestion.profile_picture}
                      alt="profile"
                      sx={imageStyles}
                    />
                  ) : (
                    <Icon as={FaUserCircle} sx={iconStyles} />
                  )}
                </Flex>
                <Flex direction="column" color="gray.100" ml={2}>
                  <Text sx={nameHead}>{suggestion.display_name}</Text>
                  <Text sx={nameDesc}>{suggestion.email}</Text>
                </Flex>
              </Flex>
            );
          }}
        />
      </MentionsInput>

      <Box textAlign="right">
        <ButtonGroup mt={2} mb={3}>
          <Button
            variant="secondary"
            onClick={() => onDiscardComment()}
            disabled={!comment}
            size="sm"
          >
            {t("cancel")}
          </Button>

          <Button
            type="submit"
            onClick={() => onUpdateComment(commentObj)}
            variant="solid"
            disabled={!comment}
            size="sm"
          >
            {t("send")}
          </Button>
        </ButtonGroup>
      </Box>
    </>
  );
};

const CommentActionDropdown = ({
  comment,
  reply,
  onAddReply,
  onResolvedComment,
  onEditComment,
  onDeleteComment,
  canEditOrReply,
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <Menu isLazy>
      <MenuButton as={IconButton} icon={<FaEllipsisV />} variant="unstyled" />

      <MenuList minWidth="8rem">
        <MenuItem
          icon={<FaCheckCircle />}
          onClick={() => onResolvedComment(reply ? reply : comment)}
        >
          {t("resolve")}
        </MenuItem>
        {canEditOrReply ? (
          <>
            <MenuItem
              icon={<FaPencilAlt />}
              onClick={() => onEditComment(reply ? reply : comment)}
            >
              {t("edit")}
            </MenuItem>
            <MenuItem
              icon={<FaTrash />}
              onClick={() => onDeleteComment(reply ? reply : comment)}
            >
              {t("delete")}
            </MenuItem>
          </>
        ) : null}
      </MenuList>
    </Menu>
  );
};

export class TldrCommentPanel extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      comment: "",
      isEditing: false,
      isSubmitting: false,
      editCommentId: null,
      replyParentId: null,
      panelParentId: null,
      loadedMembers: false,
      members: [],
      mentions: [],
      comments: [],
      showResolved: false,
      replyPanelOpen: false,
      newComment: "",
    };
  }

  getUpdatedCount = () => {
    return this.state.comments.reduce((acc, comment) => {
      if (comment.replies.length > 0) {
        const replies = comment.replies.filter((item) => item.status === 0);
        acc += replies.length;
      }

      if (comment.status === 0) {
        acc += 1;
      }
      return acc;
    }, 0);
  };

  createComment = (payload, signalToken) => {
    this.setState({ isSubmitting: true });
    axios
      .post(COMMENTS_ENDPOINT, payload, {
        cancelToken: signalToken,
      })
      .then((res) => {
        this.setState({
          isSubmitting: false,
          comments: res.data.parent
            ? this.state.comments.map((comment) =>
                comment.id === res.data.parent
                  ? {
                      ...comment,
                      replies: [res.data].concat(comment.replies),
                    }
                  : comment
              )
            : [res.data].concat(this.state.comments),
        });
        this.props.updateCommentCount(this.getUpdatedCount());
      })
      .catch((error) => this.setState({ isSubmitting: false }));
  };

  fetchComments = (objectPk, props, signalToken) => {
    this.setState({ isSubmitting: true });
    let url = `${COMMENTS_ENDPOINT}?object_pk=${objectPk}`;

    if (props.contentType) {
      url = `${url}&content_type=${props.contentType}`;
    }

    axios
      .get(url, {
        cancelToken: signalToken.token,
      })
      .then((res) => {
        this.setState({
          isSubmitting: false,
          comments: res.data.results,
        });
        this.props.updateCommentCount(this.getUpdatedCount());
      })
      .catch((error) => {
        this.setState({ isSubmitting: false, comments: [] });
        this.props.updateCommentCount(this.getUpdatedCount());
      });
  };

  updateComment = (id, payload, signalToken, props) => {
    this.setState({ isSubmitting: true });
    axios
      .put(`${COMMENTS_ENDPOINT}/${id}`, payload, {
        cancelToken: signalToken,
      })
      .then((res) => {
        this.setState({
          isSubmitting: false,
          comments: res.data.parent
            ? this.state.comments.map((comment) =>
                comment.id === res.data.parent
                  ? {
                      ...comment,
                      replies: comment.replies.map((item) =>
                        item.id === res.data.id ? res.data : item
                      ),
                    }
                  : comment
              )
            : this.state.comments.map((item) =>
                item.id === res.data.id ? res.data : item
              ),
        });
        this.props.updateCommentCount(this.getUpdatedCount());
      })
      .catch((error) => this.setState({ isSubmitting: false }));
  };

  deleteComment = (id, payload, props) => {
    this.setState({ isSubmitting: true });
    axios
      .delete(`${COMMENTS_ENDPOINT}/${id}`)
      .then((res) => {
        this.setState({
          isSubmitting: false,
          comments: payload.parent
            ? this.state.comments.map((comment) =>
                comment.id === payload.parent
                  ? {
                      ...comment,
                      replies: comment.replies.filter(
                        (item) => payload.id !== item.id
                      ),
                    }
                  : comment
              )
            : this.state.comments.filter(
                (item, index) => payload.id !== item.id
              ),
        });

        this.props.updateCommentCount(this.getUpdatedCount());
      })
      .catch((error) => {
        this.setState({ isSubmitting: false });
      });
  };

  onSetMember = (id, display) => {
    
    const user = this.state.members.filter(
      (member) => member.id === parseInt(id)
    )[0];

    this.setState({
      mentions: [...this.state.mentions, user.user_id],
    });
  };

  onSetComment = (event) => {
    this.setState({ comment: event.target.value, newComment: "" });
  };

  onSetNewComment = (event) => {
    this.setState({ newComment: event.target.value, comment: "" });
  };

  updateCommentInput = (e) => {
    this.setState({
      comment: e.target.value,
    });
  };

  onResolvedComment = (comment) => {
    comment["status"] = 2;
    this.onEditComment(comment);
    this.onUpdateComment(comment);
  };

  onCreateComment = (parentId, commentType) => {
    let objectPk = this.props.activeElement.id;
    let contentType = "stories.Layer";

    if (!this.props.activeElement.id) {
      objectPk = this.props.activePage.id;
      contentType = "stories.Page";
    }

    if (this.props.contentType) {
      contentType = this.props.contentType;
    }

    if (!objectPk) {
      return;
    }

    const commentContent = {
      user: this.props.auth.payload.user.pk,
      comment:
        commentType === "newcomment"
          ? this.state.newComment
          : this.state.comment,
      object_pk: objectPk,
      content_type: contentType,
    };

    if (parentId) {
      commentContent.parent = parentId;
    }

    if (this.state?.mentions?.length > 0) {
      commentContent.mentions = this.state.mentions;
    }

    this.createComment(commentContent, this.signal.token);

    this.onDiscardComment();

    analyticsTrackEvent("commented");
  };

  onDeleteComment = (comment) => {
    this.deleteComment(comment.id, comment, this.props);
  };

  onEditComment = (comment) => {
    this.setState({
      isEditing: true,
      editCommentId: comment.id,
      comment: comment.comment,
      replyParentId: null,
    });
  };

  onAddReply = (comment) => {
    this.setState({
      replyPanelOpen: true,
      replyParentId: comment.id,
      isEditing: true,
      panelParentId: comment.id,
      comment: "",
    });
  };

  onDiscardComment = () => {
    this.setState({
      isEditing: false,
      editCommentId: null,
      comment: "",
      replyParentId: null,
      newComment: "",
    });
  };

  onDiscardReply = () => {
    this.setState({
      replyPanelOpen: false,
      panelParentId: null,
    });
  };

  onUpdateComment = (comment) => {
    const commentContent = {
      ...comment,
      comment: this.state.comment ? this.state.comment : comment.comment,
      replies: [],
    };

    if (this.props.contentType) {
      commentContent.content_type = this.props.contentType;
    }

    this.updateComment(
      comment.id,
      commentContent,
      this.signal.token,
      this.props
    );
    this.onDiscardComment();
  };

  fetchCurrentMembers = () => {
    const { payload } = this.props.auth;
    axios
      .get(SHOW_MY_TEAM_MEMBERS + payload.selectedOrg + "/members")
      .then((res) => {
        this.setState({
          members: this.state.members.concat(res.data.results),
          loadedMembers: true,
        });
      })
      .catch((error) => {
        console.error("Failed to fetch current members");
      });
  };

  componentDidMount() {
    if (this.props.activeElement.id) {
      this.fetchComments(this.props.activeElement.id, this.props, this.signal);
    } else if (this.props.activePage.id) {
      this.fetchComments(this.props.activePage.id, this.props, this.signal);
    }

    this.fetchCurrentMembers();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.activeElement.id !== this.props.activeElement.id) {
      if (this.props.activeElement.id) {
        this.fetchComments(
          this.props.activeElement.id,
          this.props,
          this.signal
        );
      } else {
        this.fetchComments(this.props.activePage.id, this.props, this.signal);
      }
    }

    if (prevProps.activePage.id !== this.props.activePage.id) {
      this.fetchComments(this.props.activePage.id, this.props, this.signal);
    }
  }

  getCommentAuthorName = (comment) => {
    const firstName = comment.user_profile?.first_name?.trim();
    const lastName = comment.user_profile?.last_name?.trim();

    if (firstName || lastName) {
      return `${firstName} ${lastName}`.trim();
    }

    if (comment.user_profile?.username) {
      return comment.user_profile?.username;
    }

    // public comments;
    return comment.payload?.user_name;
  };

  render() {
    const { t } = this.props;
    const comments = this.state.comments.reduce((acc, comment) => {
      if (comment.replies.length > 0) {
        const commentWithReplies = {
          ...comment,
          replies: comment.replies.filter((item) =>
            this.state.showResolved ? true : item.status === 0
          ),
        };

        acc.push(commentWithReplies);
      } else if (this.state.showResolved || comment.status === 0) {
        acc.push(comment);
      }
      return acc;
    }, []);

    return (
      <Box>
        <div height="100%">
          <Divider mb={4} borderColor="brand.glass_light_10" borderWidth={1} />
          <NewCommentInputBox
            members={this.state.members}
            onSetMember={this.onSetMember}
            onSetComment={this.onSetNewComment}
            onCreateComment={this.onCreateComment}
            newComment={this.state.newComment}
            isSubmitting={this.state.isSubmitting}
            parentId={null}
            onDiscardComment={this.onDiscardComment}
            replyPanelOpen={this.state.replyPanelOpen}
          />
          <Divider mt={4} borderColor="brand.glass_light_10" borderWidth={1} />
          <Box mt={4} width="35%">
            <TldrChakraSelect
              options={panelOptions}
              chakraStyles={commentSelectorStyles}
              size="sm"
              defaultValue={panelOptions[0]}
              onChange={(output) => {
                this.setState({ showResolved: !this.state.showResolved });
              }}
            />
          </Box>
        </div>
        <Box className="dropdown-comment">
          {comments.length > 0
            ? comments.map((comment, index) => (
                <>
                  <Box key={comment.id} sx={commentCard}>
                    <Flex align="center">
                      <Box
                        h="2rem"
                        w="2rem"
                        border="2px solid"
                        borderColor="brand.glass_light_10"
                        borderRadius="full"
                      >
                        {comment.user_profile &&
                        comment.user_profile.profile_picture ? (
                          <Image
                            src={comment.user_profile.profile_picture}
                            alt="profile"
                            sx={imageStyles}
                          />
                        ) : (
                          <Icon as={FaUserCircle} sx={iconStyles} />
                        )}
                      </Box>

                      <Flex direction="column" color="gray.100" ml={2}>
                        <Text sx={nameHead}>
                          {this.getCommentAuthorName(comment)}
                        </Text>
                        <Text sx={nameDesc}>{comment?.last_updated} ago</Text>
                      </Flex>

                      <Flex sx={actionIcon} align="center" justify="center">
                        <CommentActionDropdown
                          comment={comment}
                          reply={null}
                          onAddReply={this.onAddReply}
                          onResolvedComment={this.onResolvedComment}
                          onEditComment={this.onEditComment}
                          onDeleteComment={this.onDeleteComment}
                          canEditOrReply={
                            comment.user === this.props.auth.payload.user.pk
                          }
                        />
                      </Flex>
                    </Flex>
                    <Box className="card-content" mt={2}>
                      {this.state.isEditing &&
                      this.state.editCommentId === comment.id ? (
                        <UpdateCommentInputBox
                          comment={this.state.comment}
                          commentObj={comment}
                          onDiscardComment={this.onDiscardComment}
                          members={this.state.members}
                          onSetMember={this.onSetMember}
                          onSetComment={this.onSetComment}
                          onUpdateComment={this.onUpdateComment}
                        />
                      ) : (
                        <Box my={3}>{parse(comment.comment)}</Box>
                      )}
                      {this.state.replyPanelOpen &&
                      this.state.panelParentId === comment.id ? (
                        <>
                          {comment.replies.length > 0 && (
                            <Button
                              onClick={() => this.onDiscardReply()}
                              variant="unstyled"
                              color="gray.300"
                              size="sm"
                              fontWeight="normal"
                              h={7}
                              display="block"
                            >
                              {t("hide_replies")}
                            </Button>
                          )}
                        </>
                      ) : (
                        <Button
                          variant="unstyled"
                          size="sm"
                          h={6}
                          fontWeight="normal"
                          onClick={() => this.onAddReply(comment)}
                          display="block"
                          color="white"
                        >
                          {comment.replies.length > 0
                            ? t("replyWithCount", {
                                count: comment.replies.length,
                              })
                            : t("reply")}
                        </Button>
                      )}
                    </Box>

                    {/* Reply starts here */}

                    {this.state.panelParentId === comment.id ? (
                      comment.replies.map((reply, index) => (
                        <Box
                          key={reply.id}
                          borderLeft="1px"
                          borderColor="brand.glass_light_10"
                        >
                          <Box background="none" pl={3} pt={3} m={0}>
                            <Flex
                              align="center"
                              mb={this.state.editCommentId === reply.id && 2}
                            >
                              <Box
                                h="2rem"
                                w="2rem"
                                border="2px solid"
                                borderColor="brand.glass_light_10"
                                borderRadius="full"
                              >
                                {reply.user_profile &&
                                reply.user_profile.profile_picture ? (
                                  <Image
                                    src={reply.user_profile.profile_picture}
                                    alt="profile"
                                    sx={imageStyles}
                                  />
                                ) : (
                                  <Icon as={FaUserCircle} sx={iconStyles} />
                                )}
                              </Box>
                              <Flex direction="column" color="gray.100" ml={2}>
                                <Text sx={nameHead}>
                                  {this.getCommentAuthorName(reply)}
                                </Text>
                                <Text sx={nameDesc}>
                                  {reply.last_updated} ago
                                </Text>
                              </Flex>

                              <Flex
                                sx={actionIcon}
                                align="center"
                                justify="center"
                              >
                                <CommentActionDropdown
                                  comment={comment}
                                  reply={reply}
                                  onAddReply={this.onAddReply}
                                  onResolvedComment={this.onResolvedComment}
                                  onEditComment={this.onEditComment}
                                  onDeleteComment={this.onDeleteComment}
                                  canEditOrReply={
                                    reply.user ===
                                    this.props.auth.payload.user.pk
                                  }
                                />
                              </Flex>
                            </Flex>
                            {/* Edit reply  */}
                            <Box mt={3} className="card-content">
                              {this.state.isEditing &&
                              this.state.editCommentId === reply.id &&
                              this.state.editCommentId !== comment.id ? (
                                <UpdateCommentInputBox
                                  comment={this.state.comment}
                                  commentObj={reply}
                                  onDiscardComment={this.onDiscardComment}
                                  members={this.state.members}
                                  onSetMember={this.onSetMember}
                                  onSetComment={this.onSetComment}
                                  onUpdateComment={this.onUpdateComment}
                                />
                              ) : (
                                <Box my={3}>{parse(reply.comment)}</Box>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <></>
                    )}

                    {/* Adding a reply to a thread */}
                    {this.state.panelParentId === comment.id &&
                      this.state.editCommentId === null && (
                        <Box border={0}>
                          <CommentInputBox
                            members={this.state.members}
                            onSetMember={this.onSetMember}
                            onSetComment={this.onSetComment}
                            onCreateComment={this.onCreateComment}
                            comment={this.state.comment}
                            isSubmitting={this.state.isSubmitting}
                            parentId={comment.id}
                            onDiscardComment={this.onDiscardComment}
                          />
                        </Box>
                      )}
                  </Box>
                </>
              ))
            : !this.state.isSubmitting && (
                <Flex
                  direction="column"
                  justify="center"
                  align="center"
                  height="100%"
                >
                  <Icon as={FaComments} color="white" height={8} width={8} />
                  <Text as="h6" fontSize="1rem" color="gray.100" my={2}>
                    {t("no_comments")}
                  </Text>
                  <Text fontSize="0.875rem" color="gray.300" textAlign="center">
                    {t("no_comments_desc")}
                  </Text>
                </Flex>
              )}
        </Box>
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  activePage: state.editor.activePage,
  activeElement: state.editor.activeElement,
});

const mapDispatchToProps = (dispatch) => ({
  updateCommentCount: (payload) => dispatch(updateCommentCount(payload)),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(TldrCommentPanel)
);
